import axios from "axios";

//export const CUSTOMERS_URL = "api/customers";
export const CUSTOMERS_URL = `${process.env.REACT_APP_API_URL}/country`;

// CREATE =>  POST: add a new customer to the server
export function createCity(city) {
  console.log('i am create city');
  return axios.post(`${CUSTOMERS_URL}/city`, { ...city });
}

  export function listCity(query) {
    console.log('I am here now city',query)
  
    return axios.get(`${CUSTOMERS_URL}/city?countryId=${query.countryId?query.countryId:""}`);
  }

  export function listCountry() {
    return axios.get(CUSTOMERS_URL);
  }
  
// READ


// UPDATE => PUT: update the customer on the server
